/* Utility functions shared by modules in Properties app. */

export function getCurrentTimestamp() {
  return Math.round(new Date().getTime() / 1000)
}
